const homeType = [
  { label: "Apartment / Flat", value: "apartment" },
  { label: "House", value: "house" },
  { label: "Farmhouse", value: "farm" },
  { label: "Shared Flat / House", value: "shared_flat" },
  { label: "Villa / Detached House", value: "villa" },
  { label: "Other", value: "other" },
];
export default homeType;
